module.exports = __webpack_public_path__ + "img/thumb_pepa001.ada9783c.png";